"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var p5 = require("p5");

var React = require("react");

var P5Wrapper =
/** @class */
function (_super) {
  __extends(P5Wrapper, _super);

  function P5Wrapper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  P5Wrapper.prototype.componentDidMount = function () {
    this.canvas = new p5(this.props.sketch, this.wrapper);

    if (this.canvas.myCustomRedrawAccordingToNewPropsHandler) {
      this.canvas.myCustomRedrawAccordingToNewPropsHandler(this.props);
    }
  };

  P5Wrapper.prototype.componentWillReceiveProps = function (newprops) {
    if (this.props.sketch !== newprops.sketch) {
      this.wrapper.removeChild(this.wrapper.childNodes[0]);
      this.canvas.remove();
      this.canvas = new p5(newprops.sketch, this.wrapper);
    }

    if (this.canvas.myCustomRedrawAccordingToNewPropsHandler) {
      this.canvas.myCustomRedrawAccordingToNewPropsHandler(newprops);
    }
  };

  P5Wrapper.prototype.componentWillUnmount = function () {
    this.canvas.remove();
  };

  P5Wrapper.prototype.render = function () {
    var _this = this;

    return React.createElement("div", {
      ref: function ref(wrapper) {
        return _this.wrapper = wrapper;
      }
    });
  };

  return P5Wrapper;
}(react_1.Component);

exports.default = P5Wrapper;